import React, { Component } from 'react';

import NotFoundContent from '../components/NotFoundContent/NotFoundContent';


class NotFoundPage extends Component {

  render() {
    const { router } = this.props;

    return (
      <div>
        <div className="container-fluid">
          <NotFoundContent
          router={router}
          />
        </div>
      </div>
    );
  }
}

export default NotFoundPage;